<template>
  <div class="wrap" v-loading="loading" element-loading-text="拼命加载中"
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">
    <div class="header-layout flex flex_align-items flex_space-between">

      <div class="header-layout-left flex flex_align-items">
        <i class="el-icon-back pointer" @click="$router.back()"></i>
        <span>{{ currentSectionObj.studySection && currentSectionObj.studySection.name || '' }}</span>
      </div>
      <div class="header-layout-right">
        <a href="https://hw.sxbicsp.cn/static/video/index.html" target="_blank">
          <i class="el-icon-camera-solid"></i>
          <span>拍照测试</span>
        </a>
      </div>
    </div>

    <!--左侧菜单-->
    <div class="course-layout flex flex_align-items" @click="clickShowMenuPopup">

      <!--      章节 -->
      <div :class="['section-list', showSectionList ? 'active' : '']">
        <dl v-for="(item,index) in courseList" :key="index" style="margin-bottom: 30px">
          <dt class="stc-title">第{{ index + 1 || '' }}章 {{ item.name || '' }}</dt>
          <dd class="stc-item flex flex_align-items pointer flex_space-between" v-for="(v,i) in item.list" :key="i"
              @click="handleSection(v)">
            <div>
              <i class="iconfont icon-sp"></i>
              <span>视频:</span>
              <span>{{ v.studySection.name || '' }}</span>
            </div>
            <div class="stc-item-desc">
              <span v-if="currentSectionId === v.id">(播放中)</span>
            </div>
          </dd>
        </dl>
      </div>

      <!--      拍照图-->
      <div :class="['section-list', showPhotoCameraUrl ? 'active' : '']">
        <img v-if="photoCameraUrl" style="height: 300px;width: 100%;margin: 20px 0" :src="photoCameraUrl" alt="">
        <div v-else style="height: 300px;width: 100%;margin: 20px 0;border: 1px solid #FFFFFF"
             class="flex flex_align-items flex_justify-center">
          <span style="color: #FFFFFF">暂无拍照图</span>
        </div>
        <ul class="photo-tip">
          <li class="photo-tip-title">360摄像头防护、摄像头区域黑屏问题。如上图所示时：</li>
          <li class="photo-tip-answer">先检查电脑是否安装360安全卫士。若没有请更换电脑重新安装。</li>
          <li class="photo-tip-answer">解决方案一：
            <ol>
              <li>打开360安全卫士 -- 我的电脑 -- 安全防护中心 -- 进入防护。</li>
              <li>找到摄像头防护选项并关闭。完成操作后重新登录考试系统或者重启电脑。（注：360安全卫士因版本不同原因可能导致部分软件的操作选项步骤不同)</li>
            </ol>
          </li>
          <li class="photo-tip-answer">解决方案二：
            <ol>
              <li>删除/卸载360安全卫士，重启电脑。</li>
            </ol>
          </li>
        </ul>
      </div>

      <!--      菜单栏-->
      <div class="course-layout-sidebar flex flex_align-items">
        <ul style="width: 100%">
          <li class="openchapter pointer" @click.stop="handleIsShow('showSectionList', 'showPhotoCameraUrl')">
            <i class="iconfont icon-zj"></i>
            <span>章节</span>
          </li>
          <li class="openchapter pointer" @click="clickSideUp">
            <i class="iconfont icon-left-circle-fill "></i>
            <span>上一节</span>
          </li>
          <li class="openchapter pointer" @click="clickSideNext ">
            <i class="iconfont icon-right-circle-fill"></i>
            <span>下一节</span>
          </li>
          <li class="openchapter pointer" @click.stop="handleIsShow('showPhotoCameraUrl', 'showSectionList') ">
            <i class=" el-icon-camera"></i>
            <span>拍照图</span>
          </li>
        </ul>
      </div>

      <div class="course-layout-center">
        <!--视频容器-->
        <div class='prism-player' ref="player" :id='playerId' :style='playStyle'></div>
        <!--播放结束提示完成 -->
        <div class="center-tip" v-if="showVideoTip">
          <div class="center-tip-content">
            <!--下一节-->
            <p class="layer flex flex_align-items" v-if="nextSection">
              <span>下一节课程： {{ nextSection.studySection && nextSection.studySection.name || '' }}</span>
              <el-button type="primary" round size="small" @click="clickSideNext">下一节
              </el-button>
            </p>
          </div>
        </div>
        <!--       小结不能播放提示  -->
        <div class="center-tip" v-if="showSelectTip">
          <div class="center-tip-content">
            <!--下一节-->
            <p class="layer flex flex_align-items">
              <span style="color: #206aff">{{ currentSectionObj.studySection.name || '' }}</span>,
              <span>当前小结播放完成，请勿重新观看，请选择其他学习视频进行观看</span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="mask-photograph" v-if="isMaskShow === '0'">
      <UploadPhoto :isVideoEnd="isVideoEnd" @changeStart="changePhoto" @changeEnd="changeEnd"
                   :currenStudySectionId="currenStudySectionId" :currentSectionObj="currentSectionObj"></UploadPhoto>
    </div>

  </div>
</template>

<script>
// import MuiPlayer from 'mui-player'
import UploadPhoto from './components/UploadPhoto'
import 'mui-player/dist/mui-player.min.css'
// import {muiPlayer} from './video-utils/desktop-plugin-setting'
import Aliplayer from "@/views/video/components/Aliplayer";
import {mixins} from "@/views/video/mixins/mixins-vedio-config";

let _this;
export default {
  name: "videoView",
  components: {
    UploadPhoto,
    "ali-player": Aliplayer
  },
  mixins: [mixins],
  data() {
    return {
      showSectionList: false,
      showVideoTip: false,
      showSelectTip: false,
      showPhotoCameraUrl: false,

      isMaskShow: '1',
      courseList: [], // 章节列表
      videoCurrentTime: '', // 当前小节播放时间
      timeupdateTimer: null, // 定时器

      currentSectionObj: {},// 播放小节的信息
      currentSectionId: '', // 当前选择小节id
      currenStudySectionId: '', // 用户小节id
      nextSection: {},// 下一节课程
      sectionList: [], // 所有小节列表
      startPhoto: false, // 播放开始上传头像

      photoCameraUrl: '',

      videoInfoIsPlay: false,
      videoHost: {},
      autoVideoPlay: 0,


      isPlayIntercept: true, // 是否进行拦截
      isVideoEnd: false, // 判断是否是结束
      isSavePcSection: true,


      isCloseWs: false, // 判断ws是否重复连接

      loading: true, // 加载提示框

    }
  },

  async mounted() {
    _this = this;
    // window.addEventListener("popstate", function(e) {
    //   if(_this.isMaskShow === '0') {
    //     alert('当前正在拍照请勿退出')
    //     history.pushState(null, null, document.URL);
    //   }
    // }, false);

    // 开启摄像头
    // this.openMedia()


    // 设置视频播放器高度
    this.height = document.documentElement.clientHeight - 80 + 'px';

    // 记录当前小节id
    this.currentSectionId = sessionStorage.getItem('sectionId')

    // 获取当前学习时长
    let sectionStudy = await this.getSectionStudy(this.currentSectionId)
    this.videoHost = sectionStudy

    // 获取视频地址
    let getCourseList = await this.getVedioURL(this.$route.query.courseId)
    this.courseList = getCourseList // 初始章节列表

    // 视频列表
    this.sectionList = this.getAllSectionList(this.courseList)

    // 获取上一节和下一节小节信息
    this.nextSection = this.getSectionNext(this.sectionList, this.currentSectionId, 'next')
    this.currentSectionObj = this.getSectionNext(this.sectionList, this.currentSectionId)
    this.currenStudySectionId = this.currentSectionObj.studySection.id

    if (this.currentSectionObj && this.currentSectionObj.isComplete === '1') this.showSelectTip = true;
    else this.showSelectTip = false;

    // 初始化视频播放器
    this.source = this.currentSectionObj.studySection.vedioURL
    this.insertScriptTag()

    setTimeout(() => {
      _this.loading = false
    }, 1500)
  },
  methods: {
    changePhoto() {
      this.isMaskShow = '1'
      this.instance.play()
      this.isPlayIntercept = false
      this.isSavePcSection = true
    },

    changeEnd() {
      this.isMaskShow = '1'
    },

    async clickSideNext() { // 下一节
      _this.savePcSection(_this.currentSectionId, _this.videoCurrentTime)
      clearInterval(this.timeupdateTimer)
      let next = this.getSectionNext(this.sectionList, this.currentSectionId, 'next')
      if (!next) return _this.$alert('下面没有课程了，请点击上一节查看', '小节提示', {
        confirmButtonText: '确定',
      });
      if (!next.studySection.vedioURL) return _this.$alert('当前小节暂无视频，请查看其他', '视频提示', {
        confirmButtonText: '确定',
      });
      let sectionStudy = await this.getSectionStudy(next.id)
      this.videoHost = sectionStudy
      if (sectionStudy.data && sectionStudy.data.isComplete === '1') this.showSelectTip = true;
      else this.showSelectTip = false;
      this.nextSection = next
      if (!next.studySection.vedioURL) {
        setTimeout(() => {
          _this.$alert('当前小节暂无视频，请查看其他', '视频提示', {
            confirmButtonText: '确定',
          });
        }, 1000)
        return false
      }
      if (!next) return false;
      this.setInitVideo(next)
      this.showVideoTip = false
    },
    async clickSideUp() { // 上一节
      _this.savePcSection(_this.currentSectionId, _this.videoCurrentTime)
      clearInterval(this.timeupdateTimer)
      let up = this.getSectionNext(this.sectionList, this.currentSectionId, 'up')
      if (!up) return _this.$alert('上面没有课程了，请点击下一节查看', '小节提示', {
        confirmButtonText: '确定',
      });
      if (!up.studySection.vedioURL) return _this.$alert('当前小节暂无视频，请查看其他', '视频提示', {
        confirmButtonText: '确定',
      });
      let sectionStudy = await this.getSectionStudy(up.id)
      this.videoHost = sectionStudy
      if (sectionStudy.data && sectionStudy.data.isComplete === '1') this.showSelectTip = true;
      else this.showSelectTip = false;
      if (!up) return false;
      this.setInitVideo(up)
      this.showVideoTip = false
    },
    // 获取上一节或者下一节课程
    getSectionNext(list, id, type) {
      let nextSection = {}
      for (let i = 0; i < list.length; i++) {
        if (list[i].id === id) {
          if (type === 'next') {
            nextSection = list[i + 1]
          } else if (type === 'up') {
            nextSection = list[i - 1]
          } else {
            nextSection = list[i]
          }
        }
      }
      return nextSection
    },
    // 获取所有小节得列表
    getAllSectionList(list) {
      let arr = []
      for (let i = 0; i < list.length; i++) {
        for (let j = 0; j < list[i].list.length; j++) {
          arr.push(list[i].list[j])
        }
      }
      return arr
    },
    // 获取章节列表
    getVedioURL(studyCourseId) {
      return new Promise(resolve => {
        this.$get(this.$API.MY_SECTION_LIST, {
          studyCourseId
        }).then(res => {
          resolve(res.data)
        })
      })
    },
    // 点击章节
    async handleSection(v) {
      // 资源拦截
      if (!v.studySection.vedioURL) return this.$alert('当前小节，暂无视频资源，请查看其他小节，或联系管理员进行添加', '小节提示', {
        confirmButtonText: '确定',
      });
      let sectionStudy = await this.getSectionStudy(v.id)
      this.videoHost = sectionStudy
      if (sectionStudy.data && sectionStudy.data.isComplete == 1) this.showSelectTip = true;
      else this.showSelectTip = false;
      // 点击章节关闭
      this.showVideoTip = false
      // 重新加载视频播放器
      this.setInitVideo(v)
    },
    // 初始化视频播放器
    setInitVideo(v) {
      // 初始化
      this.instance.dispose();
      this.instance = null
      this.videoElement = null
      this.MP_VIDEO_DOCUMENT = null
      this.startPhoto = false
      this.videoCurrentTime = 0
      this.isPlayIntercept = true
      this.isVideoEnd = false
      this.isSavePcSection = true
      clearInterval(_this.timeupdateTimer)
      this.timeupdateTimer = null
      // 记录当前小节id
      this.currentSectionId = v.id
      this.currentSectionObj = v
      this.currenStudySectionId = v.studySection.id
      sessionStorage.setItem('sectionId', v.id)
      this.source = v.studySection.vedioURL
      this.insertScriptTag()
      console.log(this.showSelectTip)
    },
    // 视频播放事件
    canPhotoStart() {
      /*
      * 视频开始时是否需要拍照
      * */
      // 判断当前小节是否在本地保存，如果有就不需要在拍照
      if (Math.ceil((this.videoCurrentTime && this.videoCurrentTime)) < 3 && this.isPlayIntercept) {
        this.isSavePcSection = false
        this.isMaskShow = '0'
        this.instance.pause()
        setTimeout(() => {
          this.isSavePcSection = true
        }, 300)
      }
    },
    canPhotoEnd() {
      this.isMaskShow = '0'
    },
    // 保存学习进度
    savePcSection(memberSectionId, studyTime) {
      this.$get(this.$API.SAVE_PC_SECTION, {
        memberSectionId,
        studyTime: Math.ceil(studyTime),
      })
    },
    setIntervalFn() {
      if (this.timeupdateTimer) return false;
      this.timeupdateTimer = setInterval(() => {
        _this.savePcSection(_this.currentSectionId, _this.videoCurrentTime)
      }, 180000)
    },
    // 获取学习时长
    getSectionStudy(memberSectionId) {
      return new Promise(resolve => {
        this.$get(this.$API.MY_SECTION_DETAIL, {
          memberSectionId
        }).then(res => {
          resolve(res)
        })
      })
    },
    clickShowMenuPopup() { // 点击章节
      this.showSectionList = false
      this.showPhotoCameraUrl = false
    },
    handleIsShow(show, hide) {
      this.photoCameraUrl = ''
      this[show] = !this[show]
      this[hide] = false

      if (show === 'showPhotoCameraUrl') {
        if (this['showPhotoCameraUrl']) {
          this.$get(this.$API.Member_Section_Photo_Info, {
            memberSectionId: this.currentSectionObj.id
          }).then(res => {
            this.photoCameraUrl = res.data && res.data.photo
          })
        }
      }
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeupdateTimer)
    this.timeupdateTimer = null
    // 保存学习记录
    this.savePcSection(this.currentSectionId, this.videoCurrentTime)
  },
}
</script>

<style scoped lang="scss">
.wrap {
  min-height: 500px;
}

.header-layout {
  height: 60px;
  padding: 0 20px;
  background: #FFFFFF;

  &-left {
    i {
      font-size: 25px;
    }

    span {
      font-size: $font-size-md;
      color: $font-text-color;
      font-weight: 700;
      margin-left: 10px;
    }
  }

  &-right {
    a {
      display: flex;
      align-items: center;

      i {
        font-size: 30px;
        margin-right: 5px;
      }

      span {
        font-size: 18px;
      }
    }
  }
}

.course-layout {
  position: relative;

  &-sidebar {
    background: #1c1f21;
    width: 60px;
    display: flex;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 99;
    justify-content: center;

    .openchapter {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 10px 0;
      color: $icon-color-videoView;

      i {
        font-size: 25px;
        margin-bottom: 10px;
      }

      span {
        font-size: $font-size-base;
      }

      &:hover {
        background: #26292c;
      }
    }
  }

  &-center {
    margin-left: 60px;
    flex: 1;
    position: relative;
    overflow: hidden;

    .center-tip {
      width: 100%;
      height: 100%;
      position: absolute;
      background: #000;
      left: 0;
      top: 0;
      z-index: 10;
      display: flex;
      align-items: center;
      justify-content: center;

      &-content {
        color: $font-text-color-inverse;

        .layer {
          margin-bottom: 30px;
        }

        span {
          margin: 0 20px;
        }
      }
    }
  }

  .section-list {
    position: absolute;
    left: -400px;
    top: 0;
    bottom: 0;
    width: 400px;
    height: 100%;
    background: #26292c;
    z-index: 10;
    transition: .3s all linear;
    opacity: 0;
    padding: 10px 20px;
    box-sizing: border-box;
    overflow: hidden;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 5px;
      height: 4px;
    }

    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px #FFFFFF;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 5px;
      background-color: skyblue;
    }

    &::-webkit-scrollbar-thumb:window-inactive {
      background: #1c1f21;
    }

    .stc-title {
      margin: 10px 0;
      color: $font-text-color-inverse;
      font-size: $font-size-base;
    }

    .stc-item {
      padding: 10px 0;
      color: $font-text-color-grey;
      font-size: $font-size-base;

      span {
        margin-left: 8px;
      }

      &-desc {

      }

      &:hover {
        color: #206aff;
      }
    }
  }

  .active {
    left: 60px;
    opacity: 1;
    z-index: 20;
  }
}

.mask-photograph {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 99;
}

//.prism-player {
//  position: relative;
//  z-index: -1;
//}
@import url(//g.alicdn.com/de/prismplayer/2.9.3/skins/default/aliplayer-min.css);

.photo-tip {
  color: #f8f8f8;

  &-title {
    font-size: 22px;
  }

  &-item {
    font-size: 18px;
  }

  &-answer {
    font-size: 18px;
    position: relative;

    //&:before{
    //  content: '';
    //  position: absolute;
    //  left: 0;
    //  top: 50%;
    //  border: 1px solid  rgba(255, 255, 255, 0.4);
    //  background-color:  rgba(255, 255, 255, 0.4);
    //  display: inline-block; // 此句为css样式展示重点🏁
    //  width: 8px;
    //  height: 8px;
    //  border-radius: 50%;
    //}
  }

  li {
    margin-bottom: 10px;
  }

  ol {
    li {
      list-style: block;
      margin-left: 20px;
    }
  }

}
</style>
